export default {
  API_ENDPOINT: process.env.REACT_APP_API_ENPOINT || 'https://secret-cove-63111.herokuapp.com',
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'entrack-client-auth-token',
}
